import collectDialogCtrl from './collectDialogCtrl'
import utils from 'utils'
class declarationTaskTrackingCtrl {
  constructor($scope, logger, httpRequest, initSortService, $timeout, sweetalert, $uibModal) {
    // 所勾选初始的数据
    $scope.selectedRows = []
    // 改变税款所属月份
    $scope.updateSearch = function () {
      queryInfo()
    }

    // 存储页面信息
    $scope.pageState = {
      idToken: localStorage.id_token,
      userInfo: JSON.parse(localStorage.user_info),
    }
    $scope.params = {
        pageSize: 2000,
        pageNum: 1,
        param: {
          isRoleOwner: '1', // 拥有本机构角色
          orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
        },
      }
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user
    $scope.selectedOrgList = [
      {
        orgId: $scope.currentUserInfo.userId,
        orgName: $scope.currentUserInfo.userName + '|' + $scope.currentUserInfo.realName,
        checked: true,
      },
    ]
    // 字典数据
    $scope.dictData = {}
    const typecodeArr = [
      'task_personStatus',
      'task_salaryStatus',
      'task_payStatus',
      'config_status',
      'task_applyStatus',
      'status',
      'department_no',
      'gs_applyType',
      'deduction_export_status',
      'voucher_download_status',
      'yes_no_flag',
    ]
    httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
      $scope.dictData = $.extend($scope.dictData, res.data.value)
    })
    // 获取所有主管税局信息
    httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
      $scope.dictDataProvince = res.data.value
    })
    //获取所属大区 获取地区时两个参数都不传，获取管理城市时事业部和地区两个都要传
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value
    })
    function getUserInfo() {
    httpRequest.get_getIvatEmployeeList().then((res) => {
        $scope.followerList = dataHandle(res.data.value)
        $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
        queryInfo()
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        companyName: '', //名称
        taxNo: '', //识别号
        personStatus: '', //人员信息报送状态
        province: '', // 主管税局所在省（市）
        salaryStatus: '', //所得项目明细表提交状态
        applyStatus: '', //综合所得税申报状态
        payStatus: '', //缴款状态
        status: '1',
        applyPeriod: utils.getLastMonthFirstLast().preMonth, // 时间
        accessToken: $scope.pageState.idToken,
      },
    }

    // 数据采集
    $scope.dataCollection = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      // if (isEnable()) {
      //   logger.logError('纳税人被禁用不允许数据采集/申报/缴款，请检查！')
      //   return
      // }
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let mapArr = selectedRowIdList.map(String)
      httpRequest.post_getRpaGsTaskCollection(mapArr, false).then((res) => {
        if (res.data.msgCode > 90000) {
          logger.logError(res.data.message)
          return
        }
        logger.logSuccess('数据采集成功，请等待RPA操作')
        queryInfo()
      })
    }
    //申报
    $scope.declare = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let declareMapArr = selectedRowIdList.map(String)
      httpRequest.post_getRpaGsTaskDeclare(declareMapArr, false).then((res) => {
        if (res.data.msgCode == 90009) {
          $timeout(() => {
            showCollectionDialog().then(() => {
              //关闭弹窗后的回调
              queryInfo()
            })
          })
        } else if (res.data.msgCode == 90011) {
          logger.logError(res.data.message)
          return
        } else if (res.data.msgCode == 90008) {
          logger.logError(res.data.message)
          return
        } else if (res.data.msgCode == 90013) {
          logger.logError(res.data.message)
          return
        }
        logger.logSuccess('申报成功，请等待RPA操作')
        queryInfo()
      })
    }
    // 打开申报弹窗
    function showCollectionDialog() {
      return $uibModal.open({
        templateUrl: 'origin-account-collect-dialog.html',
        controller: collectDialogCtrl,
        backdrop: 'static',
        openedClass: 'mod-modal mod-modal-md',
        resolve: {
          items1() {
            return $scope.selectedRows
          },
        },
      }).result
    }
    //交款
    $scope.Pay = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      let selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let PayIdArr = selectedRowIdList.map(String)
      httpRequest.post_getRpaGsTaskPayment(PayIdArr, false).then((res) => {
        if (res.data.msgCode > 90000) {
          logger.logError(res.data.message)
          return
        }
        logger.logSuccess('提示：缴款成功，请等待RPA操作')
        queryInfo()
      })
    }
    //下载完税证明
    $scope.download_TPC = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const selectedRowIdList = []
      angular.forEach($scope.selectedRows, function (item, index, array) {
        selectedRowIdList.push(item.id)
      })
      let certificateMapArr = selectedRowIdList.map(String)
      httpRequest.post_updateTaxCertificateStatus(certificateMapArr).then((res) => {
        if (res.data.success) {
          logger.logSuccess(res.data.message)
          queryInfo()
        }
      })
    }
    function isEnable() {
      let arrBoolean = $scope.selectedRows.some((res) => {
        return res.status == 0
      })
      return arrBoolean
    }
    // 重置
    $scope.reset = function () {
      $scope.param.param = {
        companyName: '', //名称
        taxNo: '', //识别号
        personStatus: '', //人员信息报送状态
        province: '', // 主管税局所在省（市）
        salaryStatus: '', //所得项目明细表提交状态
        applyStatus: '', //综合所得税申报状态
        payStatus: '', //缴款状态
        status: '1',
        applyPeriod: utils.getLastMonthFirstLast().preMonth,
        accessToken: $scope.pageState.idToken,
      }
      $scope.belleRegionCityList = []
      getUserInfo() 
    }

    // 表头排序
    $scope.orderMap = initSortService('staticPrdParam')
    $scope.selectedHandle = function selectedHandle() {
      $scope.param.orderMap = {}
      if ($scope.orderMap.sortKey)
        $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
      sessionStorage.setItem('staticPrdParam', JSON.stringify($scope.param))
      queryInfo()
    }

    // 查询展开
    $scope.isFilterCollapsed = false
    $scope.customizedConfig = {
      version: 4.4,
      queryConfig: [
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '人员信息报送状态',
          selected: true,
          default: true,
        },
        {
          label: '主管税局所在省（市）',
          selected: true,
          default: true,
        },
        {
          label: '所得项目明细表提交状态',
          selected: true,
          default: true,
        },
        {
          label: '综合所得税申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: true,
          default: true,
        },
        {
          label: '启用状态',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '申报方案',
          selected: false,
          default: false,
        },
        {
          label: '完税证明下载状态',
          selected: false,
          default: false,
        },
        {
          label: '专项扣除导出状态',
          selected: false,
          default: false,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
      table: [
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '主管税局所在省（市）',
          selected: true,
          default: true,
        },
        {
          label: '人员信息报送状态',
          selected: true,
          default: true,
        },
        {
          label: '所得项目明细表提交状态',
          selected: true,
          default: true,
        },
        {
          label: '综合所得税申报状态',
          selected: true,
          default: true,
        },
        {
          label: '缴款状态',
          selected: true,
          default: true,
        },
        {
          label: '人员信息报送结果',
          selected: true,
          default: true,
        },
        {
          label: '所得项目明细表提交结果',
          selected: true,
          default: true,
        },
        {
          label: '启用状态',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '申报方案',
          selected: false,
          default: false,
        },
        {
          label: '完税证明下载状态',
          selected: false,
          default: false,
        },
        {
          label: '异常信息提示',
          selected: false,
          default: false,
        },
        {
          label: '专项扣除导出状态',
          selected: false,
          default: false,
        },
        {
          label: '是否变更缴款状态',
          selected: false,
          default: false,
        },
        {
            label: '跟进人',
            selected: false,
            default: false,
        },
      ],
    }
    $scope.currentPage = 1 // 设置显示第一页
    $scope.maxSize = 10 // 每一叶显示记录数

    $scope.pageChanged = function () {
      // 点击页码发起查询
      queryInfo()
    }

    function queryInfo() {
      const openLoading =
        $scope.param.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null
      httpRequest
        .post_getRpaGsTaskDtoList(queryDataHandle($scope.param))
        .then((res) => {
          $scope.listData = res.data.value.list
          // 获取后台分页数据 回写分页组件
          $scope.totalItems = res.data.value.total
          $scope.param.pageNum = res.data.value.pageNum
          $scope.currentPage = ++res.data.value.prePage
          $scope.maxSize = res.data.value.pageSize
        })
        .finally(() => {
          window.layer.close(openLoading)
        })
    }
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList
        return queryData
    }
    $scope.searchlist = function () {
      queryInfo()
    }
    $scope.linkageQuery = function (enumName) {
      let departmenNoObj = $scope.dictData.department_no.find((v) => {
        return v.enumName === enumName
      })
      let belleRegionListObj = $scope.belleRegionList.find((v) => {
        return v.regionName === enumName
      })
      if (departmenNoObj) {
        $scope.departmentNo = departmenNoObj.enumCode
      }
      if (belleRegionListObj) {
        $scope.regionNo = belleRegionListObj.treeLevelCode
      }
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      }
      if (params.affiliation == '' || params.regionNo == '') return
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value
      })
    }
    //导出
    $scope.exportExel = function exportExel() {
      // taxdeclaration/sbGlGene/exportQueryGen
      let fileName = '申报任务跟踪(个人所得税)_' + $scope.param.param.applyPeriod.replace('-', '')
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem('id_token')}`
      utils.file_download(
        url,
        $scope.param.param,
        'gs_task', //type
        'POST',
        'blob',
        fileName,
        false
      )
    }
    // 还原
    $scope.reduction = (type) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作')
      }
      try {
        angular.forEach($scope.selectedRows, (item, index) => {
          if (item.applyStatus == 2 || item.applyStatus == 3) {
            logger.logError('申报已成功，不允许还原，请检查。')
            throw new Error('break')
          }
        })
      } catch (e) {
        // console.log(e,'跳出');
        return
      }
      let params = {
        ids: [],
        type,
      }
      for (let i = 0; i < $scope.selectedRows.length; i++) {
        params.ids.push($scope.selectedRows[i].id)
      }
      sweetalert
        .confirm(
          '还原提示',
          '确认需要对选择的数据进行还原操作，确认请点击【确定】按钮，否则点击【取消】按钮。'
        )
        .then(() => {
          httpRequest.post_reductionStatus(params).then((res) => {
            logger.logSuccess('还原成功')
            queryInfo()
          })
        })
    }
    $scope.changePaymentStatus = (status) => {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选中纳税人后操作')
      }
      const idList = $scope.selectedRows.map((item) => item.id).map(String)
      if (Object.is(status, 0)) {
        return httpRequest.post_rpaGsTaskChangeRpaTaskPayment({ idList, status }).then((res) => {
          logger.logSuccess('取消变更缴款状态成功')
          setTimeout(() => {
            queryInfo()
          }, 2000)
        })
      }
      sweetalert
        .confirm(
          '变更缴款状态提醒',
          '仅缴款状态为未缴款/缴款失败/待RPA缴款的数据支持变更缴款状态，其余状态的数据将自动过滤，确认需要对选择的数据进行变更缴款状态为“人工缴款成功”吗？'
        )
        .then(() => {
          httpRequest.post_rpaGsTaskChangeRpaTaskPayment({ idList, status }).then((res) => {
            logger.logSuccess('变更缴款状态成功')
            setTimeout(() => {
              queryInfo()
            }, 2000)
          })
        })
    }
  }
}
declarationTaskTrackingCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  'initSortService',
  '$timeout',
  'sweetalert',
  '$uibModal',
]
export default declarationTaskTrackingCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/declarationTaskTracking/declarationTaskTrackingCtrl.js